export default __webpack_public_path__ + "static/media/checked-circle.d274661d.svg";